// Recent searches utility functions
const RECENT_SEARCHES_KEY = 'baakas_recent_searches';
const MAX_RECENT_SEARCHES = 8;

/**
 * Save a search query to recent searches
 * @param query - The search query to save
 */
export const saveRecentSearch = (query: string): void => {
  if (!query || query.trim().length < 2) {
    return;
  }

  try {
    const sanitizedQuery = query.trim().toLowerCase();
    const recentSearches = getRecentSearches();
    
    // Remove if already exists (to move to top)
    const filtered = recentSearches.filter(q => q !== sanitizedQuery);
    
    // Add to beginning
    const updated = [sanitizedQuery, ...filtered].slice(0, MAX_RECENT_SEARCHES);
    
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
  } catch (error) {
    // localStorage might be full or disabled, fail silently
    console.warn('Failed to save recent search:', error);
  }
};

/**
 * Get all recent searches
 * @returns Array of recent search queries
 */
export const getRecentSearches = (): string[] => {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!stored) {
      return [];
    }
    
    const searches = JSON.parse(stored);
    if (Array.isArray(searches)) {
      return searches.filter((q: any) => typeof q === 'string' && q.trim().length >= 2);
    }
    
    return [];
  } catch (error) {
    return [];
  }
};

/**
 * Clear all recent searches
 */
export const clearRecentSearches = (): void => {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch (error) {
    // Fail silently
  }
};

/**
 * Remove a specific search from recent searches
 * @param query - The search query to remove
 */
export const removeRecentSearch = (query: string): void => {
  try {
    const recentSearches = getRecentSearches();
    const filtered = recentSearches.filter(q => q !== query.toLowerCase().trim());
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(filtered));
  } catch (error) {
    // Fail silently
  }
};

